module.exports = __webpack_public_path__ + "static/media/ic_audio_on.d5fb267d.svg";